import { AppModules } from './types';

// The modules where the current view can itself become a slide.
const SLIDE_FROM_CURRENT_VIEW_MODULES: AppModules[] = [
  AppModules.DASHBOARDS,
  AppModules.METAMODEL,
  AppModules.WORKSPACES,
  AppModules.REPORTS,
];

export const isAddSlideFromCurrentViewModule = (
  selectedModule: AppModules
): boolean => SLIDE_FROM_CURRENT_VIEW_MODULES.includes(selectedModule);
